import clsx from 'clsx';
import Text from '@/components/Text/Text';
import styles from './NumberedSteps.module.scss';
import Img from '@/components/Img';
import Button, { ButtonType } from '@/components/Button/Button';

export interface NumberedStepsProps {
  title: string;
  icon: {
    id: number;
    alternativeText: string | null;
    width: number;
    height: number;
    url: string;
  };
  button: {
    id: number;
    title: string;
    type: ButtonType;
    link: string;
    iconName?: string;
  };
  steps: {
    id: number;
    number: string;
    title: string;
    description: string;
  }[];
  backgroundColor?: 'dark' | 'light';
}

const NumberedSteps = ({ data }: { data: NumberedStepsProps }) => (
  <section
    className={clsx(styles.numberedStepsWrapper, 'custom', {
      [styles.dark]: data.backgroundColor === 'dark',
    })}
  >
    <section className={styles.numberedSteps}>
      <div className={styles.topRow}>
        <div className={styles.titleContainer}>
          <Text
            tag='h3'
            className={styles.title}
          >
            {data.title}
          </Text>
        </div>
        <Img
          src={data.icon.url}
          height={120}
          width={151}
          alt={data.icon.alternativeText || ''}
        />
      </div>

      <ul className={styles.steps_list}>
        {data.steps.map((step) => (
          <li
            className={styles.steps_card}
            key={step.id}
          >
            <h6 className={styles.stepNumber}>{step.number}</h6>
            <div className={styles.stepContent}>
              <Text
                tag='h6'
                className={styles.stepsTitle}
              >
                {step.title}
              </Text>
              <p className={styles.stepDescription}>{step.description}</p>
            </div>
          </li>
        ))}
      </ul>
      {data.button && (
      <div className={styles.primaryButtonContainer}>
        <Button
          type={data.button.type}
          href={data.button.link}
          iconName={data.button.iconName}
        >
          {data.button.title}
        </Button>
      </div>
      )}
    </section>
  </section>
);

export default NumberedSteps;
